module.exports = __webpack_public_path__ + "media/images/dingdong-allcare-mobile-1a4d8eb071a9cc8e1841b5605e1782aa.png";